module.exports = __webpack_public_path__ + "img/dashboard-bup.33c88fb5.svg";